import React from 'react';
import heroBg from '../assets/img/111.jpg';

function Hero() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-start overflow-hidden bg-black pt-20">
      <div className="absolute inset-0">
        <img 
          src={heroBg} 
          alt="Hero Background" 
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-black/90"></div>
        
        {/* Grid pattern overlay */}
        <div className="absolute inset-0 opacity-10">
          <div className="h-full w-full bg-grid"></div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            {/* Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-red/20 border border-red/30 rounded-full text-orange text-sm font-medium mb-8 backdrop-blur-sm animate-fade-in">
              <span className="relative flex h-2 w-2 mr-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-red"></span>
              </span>
              Global Logistics Excellence
            </div>
            
            {/* Main heading with typography */}
            <h1 className="heading-primary mb-6 leading-tight animate-slide-up text-white">
              Welcome to{' '}
              <span className="text-red">
                Stargate
              </span>
            </h1>
            
            {/* Subtitle */}
            <div className="text-xl md:text-2xl lg:text-3xl text-gray-light mb-8 leading-relaxed animate-slide-up delay-200">
              Navigating Your World with Precision and Care
            </div>
            
            {/* description */}
            <p className="text-lg md:text-xl text-gray-light mb-12 max-w-2xl leading-relaxed animate-fade-in delay-500">
              Streamline your international trade with our comprehensive logistics services. 
              From freight forwarding to customs clearance, we connect your business to global markets 
              with unmatched reliability and innovation.
            </p>

            {/* action buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-start items-start animate-slide-up delay-700">
              <button
                onClick={() => scrollToSection('services')}
                className="btn-primary text-lg px-8 py-4 shadow-glow group relative overflow-hidden"
              >
                <span className="relative z-10 flex items-center">
                  Our Services
                  <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </span>
                {/* Shimmer effect */}
                <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
              </button>
              
              <button
                onClick={() => scrollToSection('quotesection')}
                className="btn-outline text-lg px-8 py-4 group backdrop-blur-sm relative overflow-hidden"
              >
                <span className="relative z-10 flex items-center">
                  Request Quote
                  <svg className="w-5 h-5 ml-2 group-hover:rotate-12 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
        {/* Floating geometric shapes */}
        
        {/* Light rays */}
        <div className="absolute top-0 left-1/4 w-px h-32 bg-gradient-to-b from-red/50 to-transparent animate-pulse"></div>
        <div className="absolute top-0 right-1/3 w-px h-24 bg-gradient-to-b from-orange/30 to-transparent animate-pulse"></div>
      </div>
    </section>
  );
}

export default Hero;